import { useState } from "react";
import { API_BASE_URL } from "../../config/api";
import { useParams, Link } from "react-router-dom";
import PasswordInput from "../PasswordInput";

const ResetPassword = () => {
  const { token } = useParams();
  const [newPassword,     setNewPassword]     = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message,         setMessage]         = useState("");
  const [success,         setSuccess]         = useState(false);
  const [loading,         setLoading]         = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      return setMessage("Passwords do not match.");
    }
    if (newPassword.length < 6) {
      return setMessage("Password must be at least 6 characters.");
    }

    setLoading(true);
    setMessage("");

    try {
      // ✅ token goes in the URL — matches backend route /reset-password/:token
      const res  = await fetch(`${API_BASE_URL}/api/auth/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newPassword }),
      });

      const data = await res.json();

      if (res.ok) {
        setSuccess(true);
        setMessage("✅ Password reset successful! You can now login with your new password.");
      } else {
        setMessage(data.message || "Reset failed. The link may have expired.");
      }
    } catch {
      setMessage("Cannot connect to server. Make sure backend is running.");
    }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      {/* LEFT */}
      <div className="auth-left">
        <h1>Fraud Detect System</h1>
        <p>Secure access for Self-Drive Car Rental Owners</p>
      </div>

      {/* RIGHT */}
      <div className="auth-right">
        <div className="auth-box">
          <h2>Reset Password</h2>
          <p className="auth-sub">Enter your new password below</p>

          {!success ? (
            <form onSubmit={handleSubmit}>
              <PasswordInput
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                wrapperStyle={{ marginBottom: 14 }}
              />
              <PasswordInput
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                wrapperStyle={{ marginBottom: 14 }}
              />
              <button type="submit" className="primary-btn" disabled={loading}>
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          ) : (
            /* Success state — show login link */
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <div style={{ fontSize: "48px", marginBottom: "12px" }}>✅</div>
              <p style={{ color: "#15803d", fontWeight: "600", marginBottom: "20px" }}>
                Password reset successful!
              </p>
            </div>
          )}

          {message && (
            <p style={{
              marginTop: "14px",
              fontSize: "14px",
              color: success ? "#15803d" : "#dc2626",
              textAlign: "center",
            }}>
              {message}
            </p>
          )}

          <Link to="/" className="auth-link">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
